import React, {useState, useEffect} from 'react';
import one from './images/one.png'
import deux from './images/deux.png'
import trois from './images/trois.png'
import quatre from './images/quatre.png'
import cinq from './images/cinq.png'

const ModalInfo = ({ isVisible, onClose }) => {
    
    const handleClose = (e) => {
        if(e.target.id === "wrapper") onClose();
    }    
    
    if( !isVisible ) return null;
    return (
        <div className='fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center overflow-y-scroll ' id="wrapper" onClick={handleClose}>
            <div className='w-[92vw] max-w-[600px] h-full  flex flex-col'>
                <button className='text-white text-xl place-self-end' onClick={() => onClose()}>X</button>
                <div className="bg-slate-50 border border-slate-300 text-slate-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-slate-700 dark:border-slate-600 dark:placeholder-slate-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" >
                   1 - Pour ajouter un programme à l'heure actuelle faut l'ajouter 5 min après (Par exemple si c'est 12h05 et qu'il faut ajouter un programme à 12h0, faut l'ajouter à 12h10)
                   <img src={one}  height={900} width={900} alt="One"  className='mx-auto my-4'/>
                   <br/><br/>
                   2 - Ne faut jamais supprimer le programme de défault
                    <br/><br/>
                   3 - On peut ajouter un programme dans un programme 
                   <img src={deux}  height={900} width={900} alt="Deux"  className='mx-auto my-4'/>
                   <br/><br/> 
                   4 - Pour mettre le programme tous les jours faut mettre récurrence à daily 
                   <img src={trois}  height={900} width={900} alt="trois"  className='mx-auto my-4'/>
                    <br/><br/>
                   5 - Pour ajouter des programmes en des jours spécifiques faut mettre la récurrence à weekly et sélectionner en rose les jours qu'ont desii 
                   <img src={quatre}  height={900} width={900} alt="quatre"  className='mx-auto my-4'/>
                   <br/><br/>
                   6 - Pour ajouter un programme pour un seul jour faut pas mettre de récurrence et pour ajouter un programme tous les lundis(par exemple) faut mettre la récurrence à weekly et sélectionner en rose le lundi(par exemple)
                   <img src={cinq}  height={900} width={900} alt="cinq"  className='mx-auto my-4'/>
                   <br/>
                </div>
            </div>
        </div>
    )
}

export default ModalInfo;